export default __webpack_public_path__ + "static/media/nexum.0ba7b1b4.png";